import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { getWindow } from 'ssr-window';
import css from './index.module.scss';
// 2022-01-27 k.w 轮播组件
/** 后期可能需要改进添加的新功能
 * 1. steps（一次轮播跳转的图片张数）
 * 2. autoPlay (自动轮播)
 * 3. video (添加视频轮播功能)
 * 4. loop 非循环轮播(可参考CardSliderModule)
 */

const defaultStyle = {
    theme: 'white',
    fullScreen: false, // 是否全屏
    fullScreenWidth: 1920,
    loop: true, // 是否循环轮播（循环轮播默认容器中居中）
    pagination: {
        showPagination: true,
    },
    icon: {
        insideIcon: false, // 记录icon位置是否在container的list中
        iconPositionBetween: 30, // icon距离容器侧边边距
    },
    list: {
        imgWidth: 1120,
        imgHeight: 630,
        listGap: 0, // list之间间隔
        listWidth: 0,
        // listHeight: 0,
    },
    animation: {
        translateX: 0, // 容器中初始ul的偏移量
        //steps: 1,         // 一次滑动list的个数, 暂不提供（后续优化）
        duration: 500, // 一次动画效果的时长 ms
        delay: 0, // 动画延迟时间 ms
        fill: 'none', // 动画执行是否应用样式 none, forwards, backwords, both, initial, inherit
        easing: 'ease', // 动画执行速度 linear,ease, ease-in, ease-out, ease-in-out, steps(int,start|end), cubic-bezier(n,n,n,n)
        iterations: 1, // 动画执行次数
    },
    textStyle: {
        width: '924px',
        margin: '60px auto 0 auto',
        textAlign: 'center',
        lineHeight: '34px',
        fontSize: '20px',
        color: '#666',
        fontFamily: 'var(--font-family-Bold)',
        fontWeight: 600,
    },
};
const defaultData = [
    { img: '/img/banner_house_big.jpg', desc: '' },
    { img: '/img/banner_cell_big.jpg', desc: '' },
    { img: '/img/banner_house_big.jpg', desc: '' },
    { img: '/img/banner_cell_big.jpg', desc: '' },
];

export default function CustomerSwiper({ data = defaultData, cssStyle = defaultStyle }: any) {
    const styles = {
        theme: cssStyle?.theme ?? defaultStyle.theme,
        loop: cssStyle?.loop ?? defaultStyle.loop,
        fullScreen: cssStyle?.fullScreen ?? defaultStyle.fullScreen,
        fullScreenWidth: cssStyle?.fullScreenWdith ?? defaultStyle.fullScreenWidth,
        pagination: { ...defaultStyle.pagination, ...cssStyle?.pagination },
        icon: { ...defaultStyle.icon, ...cssStyle?.icon },
        list: { ...defaultStyle.list, ...cssStyle?.list },
        animation: { ...defaultStyle.animation, ...cssStyle?.animation },
        textStyle: { ...defaultStyle.textStyle, ...cssStyle?.textStyle },
        webpUrl: cssStyle?.webpUrl,
    };
    const { theme, loop, fullScreen, fullScreenWidth, pagination, icon, list, animation, textStyle, webpUrl } = styles;
    const { useRef, useState, useEffect } = useGlobal();
    const { EFPic } = createEFPic(webpUrl);

    // 获取客户端window
    const window = getWindow();
    // list容器
    const listContainerRef = useRef();
    // 默认list宽高为图片宽高, 全屏则为视窗宽度
    list.listWidth = list.listWidth || list.imgWidth;
    const [listWidth, setListWidth] = useState(fullScreenWidth);

    // 背景主题
    const isWhiteTheme = theme === 'white' || theme === '#fff' || theme === '#ffffff' || theme === 'transparent';
    // 记录当前热键(n表示数列第n项)
    const [reactiveKey, setReactiveKey] = useState(1);
    // 记录prevIcon和nextIcon是否激活显示状态
    const [activeIconPrev, setActiveIconPrev] = useState(loop ? true : reactiveKey === 1 ? false : true);
    const [activeIconNext, setActiveIconNext] = useState(loop ? true : reactiveKey === data.length ? false : true);
    // 记录当前轮播状态 1：进行中 2：静止状态
    const [statu, setStatu] = useState(2);
    // 控制内部innerIcon的显示状态（切换图片后延迟400ms显示, 过快显示会给人切换出现bug的视觉感）
    const [showInnerIcon, setShowInnerIcon] = useState(icon.insideIcon && loop);
    // 全屏的时候需默认使用1920，元素选然后计算容器宽度，在这个过程中会重新计算translate偏移量（设置600ms透明以隐藏translate重新计算的视觉bug）
    const [opacity, setOpacity] = useState(fullScreen ? 0 : 1);
    // 记录hover状态

    // 数据长度至少为2， 否则默认不显示pagination和icon
    if (data.length <= 1) {
        pagination.showPagination = false;
        setActiveIconPrev(false);
        setActiveIconNext(false);
    }
    const items = loop ? [...data.slice(-2), ...data, ...data.slice(0, 2)] : data;

    // js动效
    const animate = () => {
        const originX = parseInt(listContainerRef.current.style?.transform.split('(')[1] || 0);
        const distance =
            (1 - reactiveKey) * ((fullScreen ? listWidth : list.listWidth) + list.listGap) +
            (listContainerRef.current.offsetWidth - (fullScreen ? listWidth : list.listWidth)) / 2 -
            (fullScreen ? listWidth : list.listWidth + list.listGap) * 2;
        listContainerRef.current.animate([{ transform: `translate3d(${originX}px, 0, 0)` }, { transform: `translate3d(${distance}px, 0, 0)` }], {
            duration: animation.duration,
            delay: animation.delay,
            fill: animation.fill,
            easing: animation.easing,
            iterations: animation.iterations,
        });
        listContainerRef.current.style.transform = `translate3d(${distance}px,0,0)`;
        setStatu(2);
        // 动画执行完毕后延后400ms显示内部的icon
        if (icon.insideIcon && loop) {
            setTimeout(() => {
                setShowInnerIcon(true);
            }, 400);
        }
    };

    // 监听热键，触发轮播动效
    useEffect(() => {
        animate();
    }, [reactiveKey]);

    // 设置translate偏移量
    useEffect(() => {
        fullScreen ? setListWidth(listContainerRef?.current?.offsetWidth) : '';
        if (loop) {
            if (fullScreen) {
                listContainerRef.current.style.transform = `translate3d(${listContainerRef?.current?.offsetWidth * (-2 + (1 - reactiveKey))}px, 0, 0)`;
                setTimeout(() => {
                    setOpacity(1);
                }, 600);
            }
        } else {
            listContainerRef.current.style.transform = `translate3d(${animation.translateX}px, 0 , 0)`;
        }
    }, [window.innerWidth]);

    // 点击右移icon
    const clickPrev = () => {
        // 轮播中
        if (statu === 1) return;
        // 循环轮播
        if (loop) {
            setStatu(1);
            setShowInnerIcon(false);
            if (reactiveKey === 1) {
                listContainerRef.current.style.transform = `translate3d(${
                    (1 - (items.length - 3)) * ((fullScreen ? listWidth : list.listWidth) + list.listGap) +
                    (listContainerRef.current.offsetWidth - (fullScreen ? listWidth : list.listWidth)) / 2 -
                    ((fullScreen ? listWidth : list.listWidth) + list.listGap) * 2
                }px, 0 , 0)`;
            }
            setReactiveKey(reactiveKey === 1 ? items.length - 4 : reactiveKey - 1);
        } else {
            //  非循环轮播
            if (reactiveKey === 1) {
                setActiveIconPrev(false);
            }
            setStatu(1);
            setReactiveKey(reactiveKey - 1);
        }
    };

    // 点击左移icon
    const clickNext = () => {
        if (statu === 1) return;
        if (loop) {
            setStatu(1);
            setShowInnerIcon(false);
            if (reactiveKey === items.length - 4) {
                listContainerRef.current.style.transform = `translate3d(${
                    (listContainerRef.current.offsetWidth - (fullScreen ? listWidth : list.listWidth)) / 2 -
                    ((fullScreen ? listWidth : list.listWidth) + list.listGap)
                }px, 0 , 0)`;
            }
            setReactiveKey(reactiveKey === items.length - 4 ? 1 : reactiveKey + 1);
        } else {
            if (reactiveKey === data.length) {
                setActiveIconNext(false);
            } else {
                setStatu(1);
                setReactiveKey(reactiveKey + 1);
            }
        }
    };

    // 点击pagination小圆点
    const clickItem = (k: number) => {
        if (statu === 1) return;
        if (icon.insideIcon && loop) {
            setShowInnerIcon(false);
        }
        setStatu(1);
        setReactiveKey(loop ? k - 1 : k + 1);
    };

    return (
        <div className={`${css.customerSwiper} customerSwiper ${isWhiteTheme ? '' : 'black'}`} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
            <div className="cardSliderWrapper" style={{ width: fullScreen ? '100%' : '', opacity: opacity }}>
                <div
                    className={`${fullScreen ? '' : 'outsideIcon'} arrowIcon prevIcon`}
                    onClick={clickPrev}
                    style={{
                        display: activeIconPrev && !icon.insideIcon ? 'flex' : 'none',
                        width: icon.iconWidth,
                        height: icon.iconHeight,
                        top: `${list.imgHeight / 2}px`,
                        left: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
                <div className="sliderContent" ref={listContainerRef} id="listContainerRef">
                    <ul className="listBox">
                        {items.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    marginLeft: k === 0 ? 0 : `${parseInt(list.listGap)}px`,
                                    width: fullScreen ? `${listWidth}px` : `${list.listWidth}px`,
                                    height: 'auto',
                                }}
                            >
                                <div
                                    className="insideIcon prevIcon"
                                    onClick={clickPrev}
                                    style={{
                                        display: icon.insideIcon && loop && k - 1 === reactiveKey && showInnerIcon ? 'flex' : 'none',
                                        width: icon.iconWidth,
                                        height: icon.iconHeight,
                                        top: `${list.imgHeight / 2}px`,
                                        left: `${icon.iconPositionBetween}px`,
                                    }}
                                >
                                    <EFArrowDown className="icon" />
                                </div>
                                {fullScreen ? (
                                    <div
                                        style={{
                                            width: `${listWidth}px`,
                                            height: `${list.imgHeight}px`,
                                            position: 'relative',
                                        }}
                                    >
                                        {Array.isArray(item?.img) ? (
                                            <EFPic name={item?.img} className={'fullImgs'} alt={item.alt} />
                                        ) : (
                                            <Image src={item.img} className={'fullImgs'} layout={'fill'} alt={item.alt} />
                                        )}
                                    </div>
                                ) : (
                                    <div className="notFullImg" style={{ position: 'relative', width: `${list.listWidth}px`, height: `${list.imgHeight}px` }}>
                                        {Array.isArray(item?.img) ? (
                                            <EFPic name={item?.img} className={'fullImgs'} alt={item.alt} />
                                        ) : (
                                            <Image src={item.img} className={'fullImgs'} layout={'fill'} alt={item.alt} />
                                        )}
                                    </div>
                                )}
                                <p
                                    className="descText"
                                    style={{
                                        ...textStyle,
                                        ...{
                                            display: item.desc ? 'block' : 'none',
                                            color: isWhiteTheme ? '#666' : '#919191',
                                        },
                                    }}
                                >
                                    {item.desc}
                                </p>
                                <div
                                    className="insideIcon nextIcon"
                                    onClick={clickNext}
                                    style={{
                                        display: icon.insideIcon && loop && k - 1 === reactiveKey && showInnerIcon ? 'flex' : 'none',
                                        width: icon.iconWidth,
                                        height: icon.iconHeight,
                                        top: `${list.imgHeight / 2}px`,
                                        right: `${icon.iconPositionBetween}px`,
                                    }}
                                >
                                    <EFArrowDown className="icon" />
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div
                    className={`${fullScreen ? '' : 'outsideIcon'} arrowIcon nextIcon`}
                    onClick={clickNext}
                    style={{
                        display: activeIconNext && !icon.insideIcon ? 'flex' : 'none',
                        width: icon.iconWidth,
                        height: icon.iconHeight,
                        top: `${list.imgHeight / 2}px`,
                        right: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
                <div
                    className="pagination"
                    style={{
                        display: pagination.showPagination ? 'block' : 'none',
                        top: `${list.imgHeight - 30 - 12}px`,
                    }}
                >
                    {items.map((_item: any, k: number) =>
                        loop ? (
                            k >= 2 && k < items.length - 2 ? (
                                <span
                                    className={`pagenationItem ${reactiveKey === k - 1 ? 'activePaginationItem' : ''}`}
                                    key={k}
                                    onClick={() => clickItem(k)}
                                    style={{ marginLeft: k === 2 ? 0 : '12px' }}
                                ></span>
                            ) : (
                                ''
                            )
                        ) : (
                            <span
                                className={`pagenationItem ${reactiveKey === k - 1 ? 'activePaginationItem' : ''}`}
                                key={k}
                                onClick={() => clickItem(k)}
                                style={{ marginLeft: k === 0 ? 0 : '12px' }}
                            ></span>
                        ),
                    )}
                </div>
            </div>
        </div>
    );
}
